
document.addEventListener("DOMContentLoaded", function () {
  waitForElement();
});

function waitForElement() {
  var id = ".splide-reco-products";
  var splideElem = document.querySelector(id);


  if (splideElem != null && splideElem.querySelectorAll(".splide__slide-reco") != null) {
    splideInit(splideElem);
  } else {
    setTimeout(waitForElement, 2000);
  }
}

function splideInit(splideElem) {
  if (splideElem) {
    new Splide(splideElem, {
      type: "slide",
      arrows: false,
      pagination: false,
      gap: 10,
      padding: {
        right: 20,
      },
      perPage: 1,
      mediaQuery: "min",
      breakpoints: {
        768: {
          destroy: true,
        },
      },
    }).mount();
  }
}
